module.exports = {"short":"de","long":"German","createdBy":"danistefanovic"}


//////////////////
// WEBPACK FOOTER
// ./store/de/meta.json
// module id = dLso
// module chunks = 1